/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Support_Platformquestions_Linklabel2Inputs */

const en_settings_support_platformquestions_linklabel2 = /** @type {(inputs: Settings_Support_Platformquestions_Linklabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raise a support ticket`)
};

/**
* | output |
* | --- |
* | "Raise a support ticket" |
*
* @param {Settings_Support_Platformquestions_Linklabel2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_support_platformquestions_linklabel2 = /** @type {((inputs?: Settings_Support_Platformquestions_Linklabel2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Platformquestions_Linklabel2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_support_platformquestions_linklabel2(inputs)
});
export { settings_support_platformquestions_linklabel2 as "settings_support_platformQuestions_linkLabel" }